// Sound service using Web Audio API
const SoundService = (() => {
  let audioContext = null;
  let enabled = localStorage.getItem('soundEnabled') !== 'false';
  let volume = parseFloat(localStorage.getItem('soundVolume') || '0.3');

  const getContext = () => {
    if (!audioContext) {
      audioContext = new (window.AudioContext || window.webkitAudioContext)();
    }
    return audioContext;
  };

  const playTone = (frequency, duration, type = 'sine', fadeOut = true) => {
    if (!enabled) return;
    try {
      const ctx = getContext();
      const oscillator = ctx.createOscillator();
      const gainNode = ctx.createGain();

      oscillator.connect(gainNode);
      gainNode.connect(ctx.destination);

      oscillator.type = type;
      oscillator.frequency.setValueAtTime(frequency, ctx.currentTime);

      gainNode.gain.setValueAtTime(volume * 0.3, ctx.currentTime);
      if (fadeOut) {
        gainNode.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + duration);
      }

      oscillator.start(ctx.currentTime);
      oscillator.stop(ctx.currentTime + duration);
    } catch (e) { /* Audio not supported */ }
  };

  const playChord = (frequencies, duration, type = 'sine') => {
    frequencies.forEach((freq, i) => {
      setTimeout(() => playTone(freq, duration, type), i * 20);
    });
  };

  return {
    click: () => playTone(800, 0.05, 'sine'),
    hover: () => playTone(600, 0.03, 'sine'),
    success: () => playChord([523, 659, 784], 0.15, 'sine'),  // C-E-G chord
    error: () => playChord([311, 370], 0.2, 'square'),  // Dissonant
    notification: () => playChord([440, 554], 0.12, 'sine'),  // A-C#
    modalOpen: () => playTone(400, 0.08, 'sine'),
    modalClose: () => playTone(300, 0.06, 'sine'),
    toggle: () => playTone(700, 0.04, 'triangle'),
    dice: () => {
      [200, 250, 300, 350, 400, 500, 600, 700, 800].forEach((freq, i) => {
        setTimeout(() => playTone(freq, 0.05, 'triangle'), i * 60);
      });
    },
    setEnabled: (val) => { enabled = val; localStorage.setItem('soundEnabled', val); },
    setVolume: (val) => { volume = val; localStorage.setItem('soundVolume', val); },
    isEnabled: () => enabled,
    getVolume: () => volume,
  };
})();

export default SoundService;
